import React from 'react'
import store from '../../../redux/store'
import DeleteRevenueModal from '../components/list/delete-revenue-modal/delete-revenue-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openDeleteRevenueModal = ({ id, handleConfirm, handleError, handleAbort }) => {
  const getComponent = (close) => {
    return (
      <DeleteRevenueModal
        open
        id={id}
        store={store}
        handleConfirm={() => {
          close()
          handleConfirm()
        }}
        handleAbort={() => {
          close()
          handleAbort()
        }}
        handleError={handleError} />
    )
  }

  renderElement(getComponent)
}

export default openDeleteRevenueModal
